/**
 * Utility function to map {id, value}[] to {value, label}[] for Select
 * Adds a "-" option at the beginning for null/undefined/empty values
 */
export function mapOptionsToSelect(
	options?: { id: string | number; value: string }[],
) {
	const mappedOptions =
		options?.map((option) => ({
			value: option.id,
			label: option.value,
		})) || [];
	return mappedOptions;
}
